import React, { FC } from 'react';
import GalanoGrotesqueText from '../GalanoGrotesqueText';
import View from '../View';
import styles from './styles';

export type ErrorTextProps = {
  containerStyle?: any;
  textStyle?: any;
  text: string;
};

export const ErrorText: FC<ErrorTextProps> = (props) => {
  const { containerStyle, textStyle, text } = props;
  return (
    <View style={[styles.container, containerStyle]}>
      <GalanoGrotesqueText style={[styles.text, textStyle]}>
        {text}
      </GalanoGrotesqueText>
    </View>
  );
};

export default ErrorText;
